<template>
  <div class="fabric-container grid bg-white">
    <router-link
      tag="div"
      class="grid-body fabric-card"
      :to="{ name: 'fabric_status_status_log_view', params: { id: fabric.id } }"
    >
      <img :src="fabric.image_url" class="image" alt="" />
    </router-link>
    <div class="grid-title text-right">
      <h4>{{ $Fabric.getCode(fabric.id) }}</h4>
      <h3 class="text-capitalize semi-bold">{{ fabric.name }}</h3>
    </div>
  </div>
</template>

<script>
export default {
  props: ["fabric"],
  data() {
    return {};
  },
  methods: {
    async changeStatus(status, fabricId) {
      this.fabric.status = status;
      let res = await axios.post("fabrics/update/status", {
        status,
        fabricIds: [fabricId],
      });
      toastr.success("Successfully Changed");
    },
  },
};
</script>
<style scoped>
.fabric-container .grid-title {
  border-top: 1px solid #eee !important;
}

.fabric-container .image {
  width: 100%;
  height: 200px;
}

.fabric-container .text-capitalize {
  text-transform: uppercase;
}

.fabric-container h3 {
  margin-top: 0px;
  margin-bottom: 15px;
}

.fabric-container h4 {
  margin-bottom: 0px;
}

.fabric-container .fabric-dropdown {
  position: absolute;
  bottom: 30px;
  right: 30px;
}
.fabric-card {
  max-height: 235px !important;
  min-height: 235px;
}
</style>
